<template>
  <v-container fluid>
    <v-row class="mb-4" align="center">
      <v-col cols="auto">
        <v-btn icon @click="$router.push('/email-blast/templates')">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>
      <v-col>
        <h1 class="text-h5 font-weight-bold">
          Edit Template<span v-if="template">: {{ template.name }}</span>
        </h1>
      </v-col>
    </v-row>

    <v-card max-width="800">
      <v-card-text>
        <div v-if="loading" class="text-center py-6">
          <v-progress-circular indeterminate color="primary" />
        </div>
        <template-form v-else-if="template" :default-values="formValues" :submit-fn="handleSubmit" />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import axiosTemplate from '@/utils/axiosTemplate';
import TemplateForm from '@/components/EmailBlast/TemplateForm.vue';

export default {
  name: 'EmailBlastTemplateEdit',

  components: { TemplateForm },

  data() {
    return {
      template: null,
      loading: true,
    };
  },

  computed: {
    formValues() {
      if (!this.template) return {};
      return {
        name: this.template.name,
        subject: this.template.subject,
        description: this.template.description,
        html_content: this.template.htmlContent,
        active: this.template.active,
      };
    },
  },

  async created() {
    try {
      const { data } = await axiosTemplate(process.env.VUE_APP_GATEWAY_ENDPOINT).get(
        `v1/email-blast/templates/${this.$route.params.id}`
      );
      this.template = data;
    } catch (err) {
      console.error('Failed to load template', err);
    } finally {
      this.loading = false;
    }
  },

  methods: {
    async handleSubmit(data) {
      await axiosTemplate(process.env.VUE_APP_GATEWAY_ENDPOINT).patch(
        `v1/email-blast/templates/${this.$route.params.id}`,
        data
      );
      this.$router.push({ name: 'sendSms' });
    },
  },
};
</script>
